import React from 'react';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  slug?: string;
}

export const Breadcrumbs: React.FC<{ items: BreadcrumbItem[] }> = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="breadcrumb" className="hero-breadcrumbs mb-2">
      <ol className="breadcrumb mb-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return isLast || !item.url ? (
            <li key={index} className="breadcrumb-item active" aria-current="page">
              {item.label}
            </li>
          ) : (
            <li key={index} className="breadcrumb-item">
              <a href={item.url} onClick={(e) => {
                if (item.url?.startsWith('/')) {
                  e.preventDefault();
                  window.history.pushState(null, '', item.url);
                  window.dispatchEvent(new PopStateEvent('popstate'));
                }
              }}>
                {item.label}
              </a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
